"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuperUser = exports.ADMIN_ROLES = void 0;
var ADMIN_ROLES;
(function (ADMIN_ROLES) {
    ADMIN_ROLES["superAdmin"] = "super-admin";
    ADMIN_ROLES["supervisor"] = "supervisor";
    ADMIN_ROLES["manager"] = "manager";
    ADMIN_ROLES["producer"] = "producer";
})(ADMIN_ROLES = exports.ADMIN_ROLES || (exports.ADMIN_ROLES = {}));
function isSuperUser(adminRole) {
    return adminRole === ADMIN_ROLES.superAdmin || adminRole === ADMIN_ROLES.supervisor;
}
exports.isSuperUser = isSuperUser;
//# sourceMappingURL=index.js.map